module.exports = "/_next/static/images/howWorks-2x-85fb49ae1415e7b35c5c05cf74b4b7c3.jpg.webp";